import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import DaySection from "./DaySection";
import { PAGE_SIZE, dayLabel } from "../trainerScheduleHelpers";

function ScheduleList({ days, data, page, setPage, total, totalPages, onMark, onNote }) {
  return (
    <>
      {days.map((day) => (
        <DaySection
          key={day.date}
          title={dayLabel(day.date, data?.todayYmd, data?.tomorrowYmd)}
          bookings={day.bookings}
          onMark={onMark}
          onNote={onNote}
        />
      ))}
      {totalPages > 1 && (
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={1} flexWrap="wrap" gap={1}>
          <Typography variant="caption" color="text.secondary">
            Showing {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, total)} of {total} bookings
          </Typography>
          <Pagination
            size="small"
            color="primary"
            count={totalPages}
            page={page}
            onChange={(_, p) => setPage(p)}
            siblingCount={1}
            boundaryCount={1}
          />
        </Box>
      )}
    </>
  );
}

export default ScheduleList;
